import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingsComponent } from './settings/settings.component';
import { BulkOperationComponent } from './bulk-operation/bulk-operation.component';

const routes: Routes = [
  {
    path:'admin-settings' , component:SettingsComponent
  },
  {
    path:'bulk-operations' , component:BulkOperationComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminSettingsRoutingModule { }
